<template>
  <div style="padding:0;background:transparent;box-shadow:none">


    <el-tabs class="el-tabs" v-model="payStatusIndex" type="card" @tab-click="tabClick">
      <el-tab-pane :key="item.value" v-for="(item,index) in payStatus" lazy="true" :label="item.title" :name="'tab'+item.value" :id="'tab'+item.value">
         <div class="btnCon" style="top: -34px;">
          <el-button type="primary" size="mini" v-if="payStatusIndex=='tab92530004'" @click="getBankInfo">更新银行卡信息</el-button>
          <el-button type="primary" size="mini" v-if="payStatusIndex=='tab92530004'" @click="downloadBankPayFile">下载网银文件</el-button>
          <el-button type="primary" size="mini" v-if="payStatusIndex=='tab92530004'" @click="confirmPayAction">确认发放</el-button>
          <el-button type="primary" size="mini" v-if="payStatusIndex=='tab92530004' || payStatusIndex=='tab92530005'" @click="notPayAction">不发</el-button>
          <el-button type="primary" size="mini" v-if="payStatusIndex=='tab92530004'" @click="cachePayAction">暂缓发放</el-button>
          <el-button type="primary" size="mini" v-if="payStatusIndex=='tab92530005'" @click="notCachePayAction">取消暂缓</el-button>

          <el-button type="primary" size="mini" @click="customHeader">自定义表头</el-button>
          <el-button type="primary" size="mini" @click="exportTable">导出</el-button>
          <backBtn @reOnClick = "goBack()" style="display: inline-block;margin-left: 10px;"></backBtn>
          <!-- <el-button type="primary" size="small" @click="goBack">返回</el-button> -->

        </div>
        <div style="text-align: left">
          <el-checkbox v-model="radio" @change="changeRadioAction('accountTable'+item.value)">{{checkBoxMsg}}</el-checkbox>
        </div>
        <span slot="label">{{item.title}}<el-badge :value="item.num"></el-badge></span>
				<div style="height: calc(100vh - 135px);">
					<bsp-table :data.sync="list" :ref="'accountTable'+item.value"
          id="payOutUnderGroup"
					border
          show-footer
					:optimization="{scrollX: {gt: 400}}"
					show-overflow
          :show-header-overflow="true"
					keep-source
					resizable
					auto-resize
					width="100%"
					highlight-hover-row
          v-loading="loading"
          :ciic-data-filter.sync="listQuery"
          :footer-method="footerMethod"
          :custom-config="{storage: true}"
          @ciic-data-select="_getselect"
          @ciic-data-refresh="_getListpage">
						<vxe-table-column type="selection" width="60" fixed="left"></vxe-table-column>
						<bsp-table-column v-for="group in grounpColumns"
              :key="group.title"
              :title="group.title"
              :column="group"
              :grounpColumns="group.listColumns">
						</bsp-table-column>
					</bsp-table>
				</div>

      </el-tab-pane>
    </el-tabs>
    <!--自定义表头-->
    <el-dialog
    ref="" id="dialog1"
    width="740px"
    v-dialogDrag
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    v-loading="loading"
    title="自定义表头"
    :visible.sync="dialogheaderVisible">
      <customHeader
      :headerType="headerType"
      :headerList.sync="headerList"
      :batchId="listQuery.batchId"
      :templateId="listQuery.wageTmplId">

      </customHeader>
      <div
        class="marginTop30"
        style="text-align: center"
      >
        <el-button type="primary" @click="saveCusHeader()">
          确认
        </el-button>
        <el-button @click="dialogheaderVisible = false">
          取消
        </el-button>
      </div>
    </el-dialog>

    <!--  报盘文件弹窗-->
    <el-dialog
			ref="paybankFileDialog"
			width="800px"
			v-dialogDrag
			:close-on-click-modal="false"
			:close-on-press-escape="false"
			title="支付情况"
			v-loading="loadingFile"
			:visible.sync="paybankFileDialogVisible">
      <div class="marginTop30" style="text-align: center">
      <span>
        {{paybankError}}
      </span>
			<el-table
					:data="paybankFileList"
					border
					style="width: 100%;margin:20px">
					<el-table-column
						prop="banktype"
						label="付款银行"
						width="150">
						<template slot-scope="scope">
							<span>{{ scope.row.banktype | dictFilter(dicts)}}</span>
						</template>
					</el-table-column>
					<el-table-column prop="bankacount" label="付款账户" width="200" ><!--:showPagination="false"-->
						<template slot-scope="scope">
							<span>{{ scope.row.bankacount }}</span>
						</template>
					</el-table-column>
					<el-table-column prop="bankacount" label="收款银行" width="150" ><!--:showPagination="false"-->
						<template slot-scope="scope">
							<span>{{ scope.row.payeebanktype | dictFilter(dicts)}}</span>
						</template>
					</el-table-column>
					<el-table-column prop="paynum" label="发薪人数" width="120" ><!--:showPagination="false"-->
						<template slot-scope="scope">
							<span>{{ scope.row.paynum }}</span>
						</template>
					</el-table-column>
					<el-table-column prop="sumamount" label="发薪总额(元)" width="120" ><!--:showPagination="false"-->
						<template slot-scope="scope">
							<span>{{ scope.row.sumamount }}</span>
						</template>
					</el-table-column>
			</el-table>

        <el-button type="primary" @click="handlerPaybankFileDialog" > 确定 </el-button>
      </div>
    </el-dialog>


  </div>
</template>

<script>
    import bspTable from "@/components/bsp/bsp-table/bsp-table";
    import bspTableColumn from "@/views/wage/pay/customHeader/bsp-table-column";
    import { getListpage,updateListpage,addListpage,deleteData } from  "@/api/demo/demo"
    import {createdPayFile,getPaybankFileList} from  "@/api/wage/pay"
    import exportMethod from "@/util/export"
    import { mapGetters } from 'vuex';
    import {downloadFile,deepCopy} from "@/util/util";
    import customHeader from "@/views/wage/pay/customHeader/index";
    import {cachePayAction,notCachePayAction,notPayAction,confirmPayAction,findAllPayoutHeaderInfo,
    updataCustHeaderInfo,countAllPayNum,queryPayHistoryPage,getBankInfo} from '@/api/wage/pay'
    import backBtn from '@/wage-components/back-btn/back-btn'
    import XEUtils from 'xe-utils';

    export default {
        name: "table",
        components: {bspTableColumn, bspTable,customHeader,backBtn},
        created(){
          this.countAllPay();
          // this.idcardList = this.dicts.codeList[1010]
        },
        mounted() {

        },
      computed: {
        ...mapGetters([
          'dicts',
        ]),
      },
        data(){
            return{
                radio:false,
                checkBoxMsg:'隐藏空列',
                sumListCode:[],//合计列信息
                hiddenColumns:[],
                hidden:false,
                selectList:[],//选中的数据集合
                selectIds:[],//选中的数据集合ID
                dialogFormVisible: false,
                dialogheaderVisible: false,
                //自定义表头相关
                headerList:[],
                currentTab:'exe',
                tablePar:{
                  infoSetId:'CUS_BASE_INFO',
                  modelType:'',
                  infoItemList:[],
                  memberId:'',
                },
                showTable: false,
                list: [],
                idcardList: [],
                listChild: [],
                grounpColumns:[],
                sexList: [{
                    value: '1',
                    label: '已提交'
                }, {
                    value: '2',
                    label: '审核中'
                },{
                    value: '3',
                    label: '已完成'
                }],
                listQuery:{
                    page: 1,
                    limit: 20,
                    total:0,
                    batchId:this.$route.query.batchId,//页面跳转带回参数batchId
                    payWay:this.$route.query.payWay,//
                    wageTmplId:this.$route.query.wageTmplId,// 模板id
                    templateId:this.$route.query.wageTmplId,// 模板id
                },
                listForm: {},
                id:'',

                textMap: {
                    add: '新增',
                    update: '编辑'
                },
                dialogStatus: 'add',
                payStatus:[
                  {
                    value:'92530004',
                    title:'待发放',
                    num:0
                  },{
                    value:'92530005',
                    title:'暂缓发放',
                    num:0
                  },{
                    value:'92530002',
                    title:'已发放',
                    num:0
                  },{
                    value:'92530003',
                    title:'不发',
                    num:0
                  }
                ],
                payStatusIndex:'tab92530004',
                paybankFileDialogVisible:false,
                paybankFileList:[],
                paybankFileParam:{},
                paybankError:"",
                headerType:'1000',//薪资发放
                loadingFile:false,
                tablesIndex:[],//所有标签id
                loading:false
            }
        },
        methods: {
            changeRadioAction(table){
            if (this.radio) {
              this.hiddenAction(table);//隐藏
              //this.checkBoxMsg='重置';
            }else{
              this.resetAction(table);//重置
              //this.checkBoxMsg='隐藏空列';
            }
          },
          //重置
          resetAction(table){
              let refTable = table;
            this.hidden = false;
            if(this.$refs[refTable]){
              this.$refs[refTable][0].$refs.ciicTable.resetColumn();
            }
          },
          //隐藏
          hiddenAction(table){
            let ref = this.$refs[table][0].$refs.ciicTable;
            if(this.hiddenColumns && this.hiddenColumns.length>0){
              this.hidden=true;
              this.hiddenColumns.forEach(filed=>{
                if(filed){
                  ref.hideColumn(ref.getColumnByField(filed));
                }
              })
            }
          },
            footerMethod({ columns, data }){
              this.hiddenColumns = [];
              return [
                columns.map((column, columnIndex) => {
                  if(data&&data.length>0){
                    let columFiled = column.property;
                    let result = XEUtils.every(data,(data)=>{
                      return data[columFiled] ===0 || data[columFiled]===null || !data[columFiled]
                        || data[columFiled] === '0'|| data[columFiled] === '0.0'|| data[columFiled] === '0.00'
                    })
                    if(result){
                      this.hiddenColumns.push(columFiled)
                    }
                  }

                  if (columnIndex === 2) {
                    return '合计'
                  }
                  if (this.sumListCode.includes(column.property)) {
                    return XEUtils.sum(data, column.property)
                  }
                  return null
                })
              ]
            },
            test(context){
                console.log(context)
                console.log(this.di)
            },
            // 获取所选中的数据集合
            _getselect(selects){
              this.selectList = selects;
              this.selectIds =[];//清空
              selects.forEach(item=>{
                this.selectIds.push(item.id);
              })
              //alert(JSON.stringify(this.selectIds));
            },
            //获取列表数据
            _getListpage(){
              var params = this.listQuery;
              //根据卡页修改查询参数
              let value = '';
              let k = false;
              switch(this.payStatusIndex){
                case "tab92530004":value = "92530004"//待发放
                break;
                case "tab92530005":value = "92530005"//暂缓
                break;
                case "tab92530003":value = "92530003"//不发
                break;
                case "tab92530002":value = "92530002"//已发
                k = true;
                break;
              }
              params['payStatus'] = value
              params['headerType'] = this.headerType//薪资发放
              //获取表头及其列信息
              this.list = [];
              this.grounpColumns = [];
              console.log(params)
              this.loading = true;
              queryPayHistoryPage(params).then(res => {
                this.loading = false;
                console.log(res)
                console.log(res.data.dataList)
                this.showTable = true
                this.listQuery.total = res.data.data.total
                this.list = res.data.data.dataList
                let group = res.data.data.grounpColumns
                this.sumListCode = res.data.data.sumListCode
                group.splice(0,0,{
                  field:'empName',
                  title:'雇员姓名',
                  dataType:null,
                  fixed:'left'
                },{
                  field:'idCard',
                  title:'证件号码',
                  dataType:null,
                  fixed:'left'
                });
                if(k){
                  //如果是已发放 则追加发放时间
                  group.splice(2,0,{
                    field:'payDate',
                    title:'发放时间',
                    dataType:null,
                    fixed:'left'
                  });
                }

                this.grounpColumns = group
                console.log(this.grounpColumns)
                console.log(this.list)
              }).catch(err=>{
                this.loading = true;
              })
            },
          //保存自定义表头
          saveCusHeader(){
            if(this.headerList&&this.headerList.length==0){
              this.$message.warning('请选择表头内容')
              return ;
            }
            console.log('保存传参',this.headerList)
            let param = {
              'templateId':this.listQuery.wageTmplId,
              'headers':this.headerList,
              'headerType':this.headerType  //薪资发放
            }
            this.loading = true;
            updataCustHeaderInfo(param).then(res=>{
              this.loading = false;
              if(res.data.code==0){
                //刷新页面
                this._getListpage();
                //关闭自定义页面
                this.dialogheaderVisible=false;
                this.$message.success('自定义保存成功!');
              }else{
                this.$message.warning(res.data.msg);
              }
            });
          },
            //自定义表头
          customHeader(){
                // if(this.$refs['listForm']){
                //     this.$refs['listForm'].resetFields();
                // }
                let params = {
                  'batchId':this.listQuery.batchId
                };
                //查询薪资发放自定义表头信息
                this.dialogheaderVisible = true;
                // findAllPayoutHeaderInfo(params).then(res=>{
                //   console.log('打开窗口返回',res)
                //   this.headerData = res.data.data.allItmeList;//自定义表头数据信息所有的，带分类集的
                //   this.headerList = res.data.data.custItmeList;//自定义表头信息集，用户配置过得
                // })
            },
          cachePayAction(){
            if(this.selectIds && this.selectIds.length>0){
              this.$confirm('是否暂缓发放?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'info',
              }).then(()=>{
                cachePayAction(this.selectIds).then(res=>{
                  let re = res.data;
                  if(re.code==0){
                    this.$message.success("操作成功")
                    this._getListpage();
                    this.countAllPay();
                  }
                })
              })
            }else{
              this.$message.error( "请先勾选操作项")
            }

          },
          notPayAction(){
            if(this.selectIds && this.selectIds.length>0){
              this.$confirm('是否不发?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'info',
              }).then(()=>{
                notPayAction(this.selectIds).then(res=>{
                  let re = res.data;
                  if(re.code==0){
                    this.$message.success("操作成功")
                    this._getListpage();
                    this.countAllPay();
                  }
                })
              })
            }else{
              this.$message.error( "请先勾选操作项")
            }
          },
          notCachePayAction(){
            if(this.selectIds && this.selectIds.length>0){
              this.$confirm('是否取消暂缓?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'info',
              }).then(()=>{
                notCachePayAction(this.selectIds).then(res=>{
                  let re = res.data;
                  if(re.code==0){
                    this.$message.success("操作成功")
                    this._getListpage();
                    this.countAllPay();
                  }
                })
              })
            }else{
              this.$message.error( "请先勾选操作项")
            }

          },
          confirmPayAction(){
            if(this.selectIds && this.selectIds.length>0){
              // let selectIds = JSON.parse(JSON.stringify(this.selectIds));
              this.$confirm('是否确认发放?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'info',
              }).then(()=>{
                confirmPayAction(this.selectIds).then(res=>{
                  let re = res.data;
                    if(re.code==0){
                      this.$message.success("操作成功")
                      this._getListpage();
                      this.countAllPay();
                    }
                })
              })
            }else{
              this.$message.error( "请先勾选操作项")
            }

          },
          downloadBankPayFile(){
            this.paybankError = "";
            //文件信息
            console.log(this.selectIds)
            let batchId = this.$route.query.batchId
            let payWays = this.$route.query.payWay
            this.loadingFile = true;
            this.paybankFileList = [];
            let param = {
              batchId:batchId,
              detailIDs:this.selectIds
            }
            //查询发薪银行信息  paybankFileList
            getPaybankFileList(param).then(res=>{
              this.loadingFile = false;
              console.log('查询发薪银行信息',res)
              if(res.data.code!=0){
                this.paybankError = res.data.msg;
              }

              this.paybankFileList = deepCopy(res.data.data);
            }).catch(err=>{
              this.loadingFile=false
            })

            this.paybankFileDialogVisible = true;
            this.$set(this.paybankFileParam,'batchIds',batchId)
            this.$set(this.paybankFileParam,'payWays',payWays)
          },
          handlerPaybankFileDialog(){
            if(!this.paybankFileList || this.paybankFileList.length==0){
              this.paybankFileDialogVisible = false;
              this.$message.error("无银行数据")
              return
            }
            //下载文件
            var params =this.listQuery;
            params['detailIDs'] = this.selectIds
					  this.loadingFile = true;
            createdPayFile(params).then(res=>{
				    	this.loadingFile = false;
              downloadFile(res);
              if(res.status==200){
                this.$message.success("报盘文件下载成功！")
                //this.titileDetails()//刷新
              }else{
                this.$message.error( "报盘文件下载失败！")
              }
            }).catch(err=>{
    					this.loadingFile = false;
            })
          },
          //展示编辑表单框
          showDialog(row){
              this.dialogFormVisible = true
              this.dialogStatus='update'
              this.listForm = row

          },
          //删除数据
          deleteRow(row){
              this.id = row.id;
              deleteData(this.id).then(res=>{
                this.$message.success("删除成功")
                this._getListpage();
              })
          },
          //导出表格
          exportTable(){
            let value = '';
            switch(this.payStatusIndex){
              case "tab92530004":value = "92530004"
              break;
              case "tab92530005":value = "92530005"
              break;
              case "tab92530003":value = "92530003"
              break;
              case "tab92530002":value = "92530002"
              break;
            }
            //获取新的表头
            let newGroupCol = deepCopy(this.$refs["accountTable" + value][0].tableColums);
            newGroupCol = newGroupCol.splice(1,newGroupCol.length);
            console.log(newGroupCol)
            exportMethod(
              {
                columns: newGroupCol,
                type: "excel",
                beanName: "payoutBatchDetailServiceImpl",
                methodName: "findListMapByParams",
                batchId: this.listQuery.batchId,
                payWay: this.listQuery.payWay,
                payStatus: value,
                isSort: true,
                headerRowNum: 2,
                fileName: "工资发放明细导出",
                fileType: ".xls",
              },
              "/wage",true
            );
          },
          //返回
          goBack(){
            this.$router.go(-1);//返回上一层
          },
          //查询全部卡页的数据条数
          countAllPay(){
            let param = {
              batchId:this.$route.query.batchId,//页面跳转带回参数batchId
              payWay:this.$route.query.payWay//
            }
            countAllPayNum(param).then(res=>{
              let data = res.data.data;
              let isShow = 0;
              this.payStatus = [
                  {
                    value:'92530004',
                    title:'待发放',
                    num:0
                  },{
                    value:'92530005',
                    title:'暂缓发放',
                    num:0
                  },{
                    value:'92530002',
                    title:'已发放',
                    num:0
                  },{
                    value:'92530003',
                    title:'不发',
                    num:0
                  }
                ];
              this.tablesIndex = [];
              this.payStatus.forEach(pay=>{
                let k = true;
                for (let i = 0 ;i< data.length;i++) {
                  let item = data[i];
                  if(item.status==pay.value){
                    pay.num = item.num
                    k = false;
                    break;
                  }
                }
                if(k){
                  if(pay.value=='92530004' || pay.value=='92530005'){
                    isShow++;
                  }
                  pay.num = 0;
                }
                this.tablesIndex.push('accountTable'+pay.value);
              },isShow);

              if(isShow>1){
                this.payStatus = this.payStatus.filter((item)=> {
                   return !(item.value=='92530004' || item.value=='92530005')
                  }
                )
                this.payStatusIndex = 'tab92530002';
              }
              this._getListpage();
              this.tablesIndex.forEach(item=>{
                //初始化重置：
                this.resetAction(item);//重置
              });
            })
          },
          tabClick(tab){
            let label = tab.label
            let value = tab.name//码值
            this.payStatusIndex = value
            this._getListpage();
            this.selectIds = [];
          },
          //更新银行卡信息
          getBankInfo(){
            if(this.selectIds&&this.selectIds.length>0){
              this.$confirm("是否确定更新银行卡信息?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
              }).then(() => {
                let ids = [];
                let detailIds = [];

                this.list.forEach(item=>{
                  for (let i in this.selectIds) {
                    if(this.selectIds[i] == item.id){
                      ids.push(item.empId);
                      detailIds.push(item.id);
                    }
                  }
                },ids);

                let param={
                  'ids':ids,
                  'batchId':this.$route.query.batchId
                }
                getBankInfo(param).then(res=>{
                  let r = res.data.data
                  if(r){
                    this.$message.success('更新成功')
                    this._getListpage();
                  }
                })
              })
              .catch(()=>{

              })
            }else{
              this.$message.warning('请先选择操作项')
            }
          }
        }
    }
</script>

<style scoped>
.btnCon{
    position: absolute;
    right: 0;
    top: -30px;
}
 .el-tabs>>>.el-tabs__nav-wrap{
    	width: calc(100% - 600px);
    }
  .el-tabs >>> #tab-tab1,.el-tabs>>> .el-tabs__nav>div:nth-of-type(2){
    left: -20px;
    z-index: 9;
  }
   .el-tabs >>> #tab-tab2,.el-tabs>>> .el-tabs__nav>div:nth-of-type(3){
    left: -40px;
    z-index: 8;
  }
   .el-tabs >>> #tab-tab3,.el-tabs>>> .el-tabs__nav>div:nth-of-type(4){
    left: -60px;
    z-index: 7;
  }
  .el-tabs >>> #tab-tab4,.el-tabs>>> .el-tabs__nav>div:nth-of-type(5){
    left: -80px;
    z-index: 6;
  }
  .el-tabs >>> #tab-tab5,.el-tabs>>> .el-tabs__nav>div:nth-of-type(6){
    left: -100px;
    z-index: 5;
  }
</style>
